import { whiteTheme } from 'modules/hairmakeup/styles/themes/whiteTheme';
import styled from 'styled-components';

export const Wrap = styled.div`
  display: flex;
  max-width: 200px !important;
  width: 100% !important;
  height: 360px !important;
  position: relative;
  margin-bottom: 105px;
  background-color: #d7d7d7;
  & a,
  & a div,
  & a p,
  & img,
  & div,
  & div p,
  & p {
    width: 100% !important;
    height: 360px !important;
    display: flex;
    justify-content: center;
  }
  & ul {
    width: 100%;
    padding: 0;
    margin: 0;
  }
  & li {
    list-style-type: none;
  }
  ${whiteTheme.media.tablet} {
    max-width: 400px !important;
    height: 605px !important;
    margin-bottom: 50px;
    & a,
    & a div,
    & a p,
    & img,
    & div,
    & div p,
    & p {
      max-width: 400px;
      width: 100%;
      height: 605px;
      display: flex;
      justify-content: center;
    }
  }
  ${whiteTheme.media.tablet} {
    &.saleForMainPage a,
    &.saleForMainPage a div,
    &.saleForMainPage a p,
    &.saleForMainPage img,
    &.saleForMainPage div,
    &.saleForMainPage div p,
    &.saleForMainPage p {
      max-width: 100% !important;
      height: 100% !important;
    }
    &.verticalBanner {
      max-width: 280px !important;
      width: 100%;
      height: 450px !important;
      margin-left: auto;
      margin-right: auto;
    }
    &.verticalBanner div,
    &.verticalBanner p,
    &.verticalBanner :first-child,
    &.verticalBanner a,
    &.verticalBanner img {
      max-width: 100% !important;
      height: 100% !important;
    }
  }
  ${whiteTheme.media.mobileM} {
    height: 605px;
  }
  ${whiteTheme.media.mobileM} {
    margin-bottom: 45px;
  }
`;
